import React from 'react';
import {connect} from 'react-redux';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import {daysFetchData} from './OverviewAction';
import InfoSnack from '../utils/InfoSnack';
import List from 'material-ui/List';
import {workoutFetchData} from '../workout/WorkoutAction';
import {CircularProgress} from 'material-ui/Progress';
import DayListItem from './DayListItem';
import OverviewBar from './OverviewBar';
import ReactDOM from 'react-dom';
import moment from 'moment';
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    LinearProgress
} from 'material-ui';
import MyButton from '../components/MyButton';
import {
	navigationToInvite,
	navigationToPayout,
} from '../navigation/NavigationActions';
import WorkoutLinearProgress from '../components/WorkoutProgress';
import {fetchDeclinePayout} from '../payout/DeclinePayoutAction';
import {fetchRetry} from '../retry/RetryAction';
import PayoutTable from '../components/PayoutTable';
import './Overview.css';
import ProgressCube from '../components/ProgressCube';
import {CHEATED} from './DayStates';
import {ReCaptcha} from "react-recaptcha-v3";

class OverviewScreen extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			selectedId: '',
            open: false,
		};

		this.hasCheatedWorkout = false;
	}

	componentDidUpdate(prevProps) {
		if (this.props.days.length) {
			this.hasCheatedWorkout = !!this.props.days.find(
				(day) => day.state === CHEATED
			);
		}
		// if (ReactDOM.findDOMNode(this.refs['scrollTo'])) {
		// 	ReactDOM.findDOMNode(this.refs['scrollTo']).scrollIntoView({
		// 		behavior: 'smooth',
		// 		block: 'center',
		// 	});
		// }
		this.initNetworkError(prevProps);
	}

	componentWillMount() {
		this.performRequest();
	}

	initNetworkError(prevProps) {
		if (
			prevProps.loadingDaysFailed !== this.props.loadingDaysFailed &&
			prevProps.daysLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		} else if (
			prevProps.loadingWorkoutFailed !==
				this.props.loadingWorkoutFailed &&
			prevProps.workoutLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		}
		if (
			prevProps.workoutAlreadyMissed !==
				this.props.workoutAlreadyMissed &&
			prevProps.workoutLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:alreadyMissed'));
		}
	}

	performRequest() {
		if (this.props.workoutLoading) return;
		this.props.fetchDays();
	}

	isToday(start_deadline) {
		const start = moment(start_deadline);
		return moment(start).isSame(moment(), 'day');
	}

	progressUntilNextPayout() {
		const totalDays = 30;
		const openDays = moment(this.props.openDays);
		const passedDays = totalDays - openDays;
		return (passedDays * 100) / totalDays;
	}

	getInvitesCount() {
		const invites = this.props.invites;
		return invites.length;
	}

	getInvitesBonus() {
		const invites = this.props.invites;
		return invites.length * 20;
	}

	getTotalPayout() {
		return this.convertCentToAmount() + this.getInvitesBonus();
	}

	convertCentToAmount() {
		return Math.trunc(this.props.initialOrder.extra_payout / 100);
	}

	convertCents(cents) {
		return Math.trunc(cents / 100);
	}

	convertCentToAmountOld() {
		return Math.trunc(this.props.monthlyTotal / 100);
	}

	getPayoutAmount() {
		const total = this.props.initialOrder.total;
		const period = this.props.period;
		const extraPayout1 = this.props.initialOrder.extra_payout_1;
		const extraPayout2 = this.props.initialOrder.extra_payout_2;
		const extraPayout3 = this.props.initialOrder.extra_payout_3;
		const extraPayout4 = this.props.initialOrder.extra_payout_4;
        const totalCoupon = this.props.initialOrder.total_coupon ? this.props.initialOrder.total_coupon : 0;

		if (period === 1) {
			return this.convertCents(total * period + extraPayout1);
		} else if (period === 2) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout2);
		} else if (period === 3) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout3);
		} else if (period === 4) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout4);
		} else {
			return this.convertCents((total + totalCoupon) * 4 - totalCoupon + extraPayout4);
		}
	}

	getPayoutAmountIncreased() {
		const total = this.props.initialOrder.total;
		const period = this.props.period + 1;
		const extraPayout1 = this.props.initialOrder.extra_payout_1;
		const extraPayout2 = this.props.initialOrder.extra_payout_2;
		const extraPayout3 = this.props.initialOrder.extra_payout_3;
		const extraPayout4 = this.props.initialOrder.extra_payout_4;
        const totalCoupon = this.props.initialOrder.total_coupon ? this.props.initialOrder.total_coupon : 0;

		if (period === 1) {
			return this.convertCents(total * period + extraPayout1);
		} else if (period === 2) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout2);
		} else if (period === 3) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout3);
		} else if (period === 4) {
			return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout4);
		} else {
			return this.convertCents((total + totalCoupon) * 4 - totalCoupon + extraPayout4);
		}
	}
	getDaysUntilPayout() {
		const nextPayoutDate = moment(this.props.nextPayout);

		if (nextPayoutDate) {
			return Math.abs(moment().diff(nextPayoutDate, 'days'));
		} else {
			return 0;
		}
	}

	getDaysUntilPayoutString(count){
        const {t} = this.props;
        return t('common:daysLeft', {count: count});
	}

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

	render() {
		const {t} = this.props;
		return (
			<div className='screenWrapper noSelectAtAll'>
				<ReCaptcha
					sitekey="6Lc-2_gUAAAAAL9yUANfRxC2hRbPFI0jTvlvVQPB"
					action='overview_screen'
				/>

				<Dialog
					open={this.state.open}
					onClose={this.handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{t('overview:retryDialogTitle')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
                            {t('overview:retryDialogDescription')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleClose} color="primary">
                            {t('common:cancel')}
						</Button>
						<Button onClick={() => {
                            this.handleClose();
                            this.props.fetchRetry();
                        }} color="primary" autoFocus>
                            {t('overview:retry')}
						</Button>
					</DialogActions>
				</Dialog>

				<div className='overviewWrapper'>
					<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
					<OverviewBar />

					{this.props.betMode === 2 && !this.hasCheatedWorkout && this.props.retry === false && this.props.initialOrder.variation !== "1" && (
						<React.Fragment>
							<ProgressCube
								t={this.props.t}
								currentStep={this.props.period}
								daysremaining={this.getDaysUntilPayoutString(this.getDaysUntilPayout())}
								initialOrder={this.props.initialOrder}
							/>
						</React.Fragment>
					)}

					{(this.props.offerPayout && this.props.betMode === 2 && this.props.period <= 5) ===
						true && (
						<React.Fragment>
							<div className='endOrContinueWrapper'>
								<h3
									style={{
										color: '#028AED',
									}}
								>
									{t('overview:payoutTitle')}
								</h3>
								<br />
                                {this.props.period <= 4 && (
								<p>
									{t('overview:payoutDescription', {
										payoutAmount: this.getPayoutAmount(),
										increasedBy:
											this.getPayoutAmountIncreased() -
											this.getPayoutAmount(),
										increasedAmount: this.getPayoutAmountIncreased(),
										days:
											this.props.initialOrder
												.workouts_per_order * 30,
									})}
								</p>)}
                                {this.props.period === 5 && (
									<p>
                                        {t('overview:payoutDescriptionMaximum', {payoutAmount: this.getPayoutAmount()})}
									</p>)}
								<div className='endOrContinueCTA'  style={{marginTop: 12}}>
									<MyButton
										variant='flat'
										style={{
											height: 35,
											backgroundColor:
												colors.primaryColor,
											color: colors.white,
										}}
										onPressButton={() =>
											this.props.fetchDeclinePayout()
										}
										title={this.props.t(
											'common:dontPayout'
										)}
										color='secondary'
										size='large'
										fullWidth={true}
										loading={
											this.props.declinePayoutLoading
										}
									/>
									<MyButton
										style={{
											height: 35,
											marginTop: 12,
											backgroundColor:
												colors.primarySuperLight,
											color: colors.primaryLight,
										}}
										variant='flat'
										onPressButton={() =>
											this.props.navigationToPayout()
										}
										title={this.props.t('common:doPayout')}
										color='primary'
										size='large'
										fullWidth={true}
										loading={false}
									/>
								</div>
							</div>
							<br />
						</React.Fragment>
					)}

					{(this.props.retry && this.props.betMode === 2) ===
						true && (
						<React.Fragment>
							<div className='retryWrapper'>
								<h3>{t('overview:missedRetryTitle')}</h3>
								<br />
								<p className='retryRationale'>
									{t('overview:missedRetryDescription')}
								</p>
								<div className='retryCTA' style={{marginTop: 12}}>
									<MyButton
										style={{
											height: 35,
											backgroundColor: '#fff',
											color: colors.primaryColor,
										}}
										onPressButton={() =>
											this.handleClickOpen()
										}
										title={this.props.t('overview:retry')}
										color='secondary'
										size='large'
										fullWidth={true}
										loading={this.props.retryLoading}
										variant='raised'
									/>
								</div>
							</div>
							<br />
						</React.Fragment>
					)}
					{/* add cheated text */}
					{this.hasCheatedWorkout && this.props.betMode === 2 && (
						<React.Fragment>
							<div className='retryWrapper'>
								<h3>{t('overview:cheatedRetryTitle')}</h3>
								<br />
								<p className='retryRationale'>
									{t('overview:missedRetryDescription')}
								</p>
								<div className='retryCTA' style={{marginTop: 12}}>
									<MyButton
										style={{
											height: 35,
											backgroundColor: '#fff',
											color: colors.primaryColor,
										}}
										onPressButton={() =>
                                            this.handleClickOpen()
										}
										title={this.props.t('overview:retry')}
										color='secondary'
										size='large'
										fullWidth={true}
										loading={this.props.retryLoading}
										variant='raised'
									/>
								</div>
							</div>
							<br />
						</React.Fragment>
					)}

					{/*legacy, monthly refund*/}
					{this.props.betMode !== 1 && this.props.betMode !== 2 && (
						<div style={styles.profileInfoOuter}>
							<div style={styles.profileInfoContainer}>
								<div style={styles.profileInfo}>
									<div style={styles.payoutTitleContainer}>
										<h3 style={styles.flex1}>
											{t('overview:motivation_title')}
										</h3>
										<h4>
											{this.convertCentToAmountOld()}€
										</h4>
									</div>
									<p style={styles.payoutDescription}>
										{t('overview:open', {
											count: this.props.openDays,
										})}
									</p>
									<LinearProgress
										color='primary'
										variant='determinate'
										value={this.progressUntilNextPayout()}
									/>
									<div style={styles.separator}></div>
									<div style={styles.payoutTitleContainer}>
										<h4 style={styles.flex1}>
											{t('overview:invited_friends')} (
											{this.getInvitesCount()})
										</h4>
										<h4>+ {this.getInvitesBonus()}€</h4>
									</div>
									<p style={styles.friendsDescription}>
										{t('overview:friends')}
										<b>{t('overview:friends_amount')}</b>
									</p>

									<MyButton
										style={{
											height: 50,
											marginTop: 12,
										}}
										onPressButton={() =>
											this.props.navigationToInvite()
										}
										title={this.props.t(
											'overview:more_payout'
										)}
										color='primary'
										size='large'
										loading={false}
										variant='raised'
									/>
								</div>
							</div>
						</div>
					)}

					{/*legacy, no monthly refund*/}
					{this.props.betMode === 1 && this.props.showInviteFriends && (
						<div style={styles.profileInfoOuter}>
							<div style={styles.profileInfoContainer}>
								<div style={styles.profileInfo}>
									<div style={styles.payoutTitleContainer}>
										<h4 style={styles.flex1}>
											{t('overview:payout')}
										</h4>
										<h4>{this.convertCentToAmount()}€</h4>
									</div>
									<div style={styles.separator}></div>
									<div style={styles.payoutTitleContainer}>
										<h4 style={styles.flex1}>
											{t('overview:invited_friends')} (
											{this.getInvitesCount()})
										</h4>
										<h4>+ {this.getInvitesBonus()}€</h4>
									</div>
									<p style={styles.friendsDescription}>
										{t('overview:friends')}
										<b>{t('overview:friends_amount')}</b>
									</p>
									<div style={styles.separator}></div>
									<div style={styles.payoutTitleContainer}>
										<h4 style={styles.flex1}>
											{t('overview:total')}
										</h4>
										<h4>{this.getTotalPayout()}€</h4>
									</div>

									<MyButton
										style={{
											height: 50,
											marginTop: 12,
										}}
										onPressButton={() =>
											this.props.navigationToInvite()
										}
										title={this.props.t(
											'overview:more_payout'
										)}
										color='primary'
										size='large'
										loading={false}
										variant='raised'
									/>
								</div>
							</div>
						</div>
					)}

					{this.props.days && !!this.props.days.length && (
						<div className='listWrapper'>
							<List style={{padding: 8}}>
								{this.props.days.map((item, index) => (
									<DayListItem
										actionsDisabled={
											this.props.retry ||
											this.hasCheatedWorkout
										}
										ref={
											this.isToday(item.start_deadline)
												? 'scrollTo'
												: ''
										}
										id={item._id}
										key={item._id}
										index={index}
										onPressItem={this.onPressItem}
										day={item}
										isToday={this.isToday(
											item.start_deadline
										)}
										loading={
											this._isSelected(item._id) &&
											this.props.workoutLoading
										}
									/>
								))}
							</List>
						</div>
					)}
					{this.props.daysLoading && this.props.days.length === 0 && (
						<div
							style={styles.loadingIndicator}
							className='loadingIndicator'
						>
							<CircularProgress size={50} />
						</div>
					)}
				</div>
			</div>
		);
	}

	_isSelected(id) {
		return this.state.selectedId === id;
	}

	onPressItem = (item) => {
		if (this.props.workoutLoading) return;

		this.setState((state) => {
			return {
				selectedId: item._id,
			};
		});
		this.props.fetchWorkout(item._id);
	};
}

const styles = {
	profileInfoContainer: {
		maxWidth: 1200,
		margin: '0 auto',
		padding: 16,
	},
	profileInfoOuter: {
		backgroundColor: colors.primaryColor,
		width: '100%',
	},
	paddingToBar: {
		paddingTop: 56,
	},
	profileInfo: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: colors.white,
		padding: 16,
		borderRadius: 4,
		boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
	},
	loadingIndicator: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginTop: 24,
	},
	workingInline: {
		paddingTop: 56,
		marginTop: -56,
	},
	payoutDescription: {
		marginBottom: 12,
	},
	friendsDescription: {
		color: colors.text,
		paddingBottom: 5,
	},
	friendsContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
	},
	payoutTitleContainer: {
		display: 'flex',
		flexDirection: 'row',
	},
	payoutAmount: {
		color: colors.white,
		backgroundColor: colors.primaryColor,
		borderRadius: 4,
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 6,
		paddingRight: 6,
	},
	separator: {
		height: 1,
		backgroundColor: colors.separator,
	},
};

const mapStateToProps = (state) => {
	return {
		days: state.days,
		monthlyTotal: state.monthlyTotal,
		userOnTrack: state.userOnTrack,
		openDays: state.openDays,
		initialOrder: state.initialOrder,
		betMode: state.betMode,
		invites: state.invites,
		loadingDaysFailed: state.loadingDaysFailed,
		declinePayoutLoading: state.declinePayoutLoading,
		daysLoading: state.daysLoading,
		workoutLoading: state.workoutLoading,
		loadingWorkoutFailed: state.loadingWorkoutFailed,
		workoutAlreadyMissed: state.workoutAlreadyMissed,
		showInviteFriends: state.showInviteFriends,
		offerPayout: state.offerPayout,
		retry: state.retry,
		nextPayout: state.nextPayout,
		periodBegin: state.periodBegin,
		period: state.period,
		retryLoading: state.retryLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchDays: () => dispatch(daysFetchData()),
		fetchWorkout: (dayId) => dispatch(workoutFetchData(dayId)),
		fetchDeclinePayout: () => dispatch(fetchDeclinePayout()),
		fetchRetry: () => dispatch(fetchRetry()),
		navigationToInvite: () => dispatch(navigationToInvite()),
		navigationToPayout: () => dispatch(navigationToPayout()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['overview', 'common'])(OverviewScreen));



// WEBPACK FOOTER //
// ./src/overview/OverviewScreen.js